import { render, staticRenderFns } from "./NumberImport.vue?vue&type=template&id=2cad270a"
import script from "./NumberImport.vue?vue&type=script&lang=js"
export * from "./NumberImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports